import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { HelpDocsService } from '@mode/shared/util-js';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconComponent],
  selector: 'mode-discover-sidebar',
  templateUrl: './discover-sidebar.component.html',
  styleUrls: ['./discover-sidebar.component.scss'],
  providers: [HelpDocsService],
})
export class DiscoverSidebarComponent {
  constructor(public helpDocs: HelpDocsService) {}

  public nowLiveLinks = [
    {
      title: 'Now Live: Datasets, Curated Building Blocks for Self-Service Data Exploration',
      href: 'https://mode.com/blog/introducing-reusable-datasets-for-self-serve/',
      testAttribute: 'dataset-link',
    },
    {
      title: 'Now Live: Faster, Easier, and More Customizable Visualizations in Mode',
      href: 'https://mode.com/blog/faster-easier-customizable-bi-visualizations-in-mode/',
      testAttribute: 'viz-link',
    },
    {
      title: 'Product Updates: January 2023',
      href: 'https://mode.com/blog/jan-23-product-updates-shared-axis/',
      testAttribute: 'product-update-link',
    },
    {
      title: 'Mode’s dbt Integration vs Datasets: How They’re Different and When You Should Use Them',
      href: 'https://mode.com/blog/the-difference-between-datasets-and-dbt/',
      testAttribute: 'dbt-link',
    },
    {
      title: 'Visual Explorer How-To Guide',
      href: 'https://mode.com/visual-explorer-guides/',
      testAttribute: 'viz-quide-link',
    },
    {
      title: 'Introducing Visual Explorer for Data Exploration',
      href: 'https://mode.com/blog/introducing-visual-explorer/',
      testAttribute: 'viz-data-explorer-link',
    },
  ];
  public gettingStartedOptions = [
    {
      title: 'Datasets',
      href: 'https://university.mode.com/getting-started-with-datasets',
      testAttribute: 'get-started-datasets-link',
    },
    {
      title: 'Visual Explorer',
      href: 'https://university.mode.com/what-is-visual-explorer-1',
      testAttribute: 'get-started-viz-explorer-link',
    },
    {
      title: 'SQL Editor',
      href: 'https://university.mode.com/sql-editor-tips-tricks-1',
      testAttribute: 'get-started-sql-editor-link',
    },
    {
      title: 'Calculated Fields',
      href: 'https://university.mode.com/introduction-to-calculated-fields',
      testAttribute: 'get-started-calculated-fields-link',
    },
    {
      title: 'Explorations',
      href: 'https://university.mode.com/using-explorations-for-visual-analysis',
      testAttribute: 'get-started-explorations-link',
    },
    {
      title: 'Chart Building',
      href: 'https://university.mode.com/page/video-library#topics_visualization',
      testAttribute: 'get-started-chart-building-link',
    },
    {
      title: 'Notebooks',
      href: 'https://university.mode.com/introduction-to-notebooks',
      testAttributes: 'get-started-notebooks-link',
    },
  ];
  public helpfulLinks = [
    {
      title: 'Mode University',
      href: 'https://university.mode.com/',
      testAttribute: 'mode-university-link',
    },
    {
      title: 'Mode Blog',
      href: 'https://mode.com/blog/',
      testAttribute: 'mode-blog-link',
    },
    {
      title: 'Mode Support',
      href: this.helpDocs.links['https://mode.com/help'],
      testAttribute: 'mode-support-link',
    },
    {
      title: 'API Reference Guide',
      href: 'https://mode.com/developer/api-reference/introduction/',
      testAttribute: 'api-reference-guide-link',
    },
    {
      title: 'SQL Tutorials',
      href: 'https://mode.com/sql-tutorial/',
      testAttributes: 'mode-sql-tutorials-link',
    },
    {
      title: 'Visual Explorer Field Guides',
      href: 'https://mode.com/visual-explorer-guides/',
      testAttribute: 'mode-viz-explorer-link',
    },
  ];
}
